import React, { useEffect, useRef, useState } from "react";
import {
  uomGroupDeleteAction,
  uomGroupTableListAction,
} from "../../../../redux/actions/settings-action";
import { useDispatch } from "react-redux";
import KibabMenu from "../../../../assets/icons/kibab-menu";
import checkBoxRightArrow from "../../../../assets/icons/checkBoxRightArrow.svg";
import checkBoxDownArrow from "../../../../assets/icons/checkBoxDownArrow.svg";
import EditIcon from "../../../../assets/icons/editIconPencil.svg";
import DeleteIcon from "../../../../assets/icons/delete-icon";
import search from "../../../../assets/icons/searchIcon.svg";
import errorToast from "../../../helper-components/error-toast";
import LoadingSpinner from "../../../helper-components/loading-spinner";
import InnerLayout from "../../../layouts/inner-layout";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import successToast from "../../../helper-components/success-toast";
import Select from "react-select";
import DownloadIcon from "../../../../assets/icons/download-icon";
import { downloadAllTemplates } from "../../../helper-components/helper-function";
import excelImg from "../../../../assets/icons/excel.png";
import BulkUomGroupModal from "./bulk-uom-group-modal";
import { customStyles } from "../../../tables/filtering-section2";

const UomGroup = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const searchRef = useRef();
  const searchFilter = [
    {
      label: "Group Name",
      value: "name",
    },
  ];
  const [isFocused, setIsFocused] = useState(true);
  const [filterData, setFilterData] = useState({
    searchColumn: "name",
    searchValue: "",
  });

  const tableHeading = [
    "Group Name",
    "Group Description",
    "Group code",
    "Actions",
  ];
  const itemTableHeaders = ["Alt Qty", "Alt UOM", "Base Qty", "Base UOM"];
  const [uomGroupData, setUomGroupData] = useState([]);
  const [showItemsOf, setShowItemsOf] = useState(null);
  const [selectedDOtIndex, setSelectedDotIndex] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [mainLoading, setMainLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //   useEffect(() => {
  //     dispatch(
  //       uomGroupTableListAction(
  //         {},
  //         onFetchUomGroupListSuccess,
  //         onFetchUomGroupListError
  //       )
  //     );
  //     setMainLoading(true);
  //   }, []);

  useEffect(() => {
    setMainLoading(true);
    dispatch(
      uomGroupTableListAction(
        filterData,
        onFetchUomGroupListSuccess,
        onFetchUomGroupListError
      )
    );
  }, [filterData, reloadData]);

  const reload = () => {
    dispatch(
      uomGroupTableListAction(
        {},
        onFetchUomGroupListSuccess,
        onFetchUomGroupListError
      )
    );
    setMainLoading(true);
  };

  const onFetchUomGroupListSuccess = (data) => {
    setUomGroupData(data?.data?.uomList);
    setMainLoading(false);
  };

  const onFetchUomGroupListError = (data) => {
    setMainLoading(false);
    setUomGroupData([]);
    errorToast(data?.message);
  };

  const onCLickEdit = (data) => {
    navigate(`/settings/uom-group-setup/edit/${data.group_id}`, {
      state: { editingData: data },
    });
    setSelectedDotIndex(null);
  };

  const onClickDelete = (id) => {
    dispatch(uomGroupDeleteAction({ group_id: id }, onDeletSuccess, onError));
    setSelectedDotIndex(null);
  };
  const onDeletSuccess = (data) => {
    successToast(data?.message);
    reload();
  };

  const onError = (data) => {
    const message = data?.data?.message ?? data?.message;
    errorToast(message ?? "Cannot delete. This UOM group is already assigned to items.");
  };

  const componentRef = useRef(null);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setSelectedDotIndex(null);
    }
  };
  const handleSelectChange = (event) => {
    setFilterData({ ...filterData, searchColumn: event?.value });
  };

  return (
    <InnerLayout
      list={true}
      title="Settings"
      module="uom-group-setup"
      // permissionFn={permissionFn}
    >
      <div
        className="flex flex-col h-full mx-6"
        // style={{ height: "80vh" }}
        onClick={handleClickOutside}
      >
        <div className="flex justify-between pt-3 items-center  py-3 h-[4rem]">
          <div className="flex items-center gap-2 text-sml">
            <button
              className="flex items-center gap-2"
              onClick={() => {
                navigate("/settings");
              }}
            >
              <ChevronLeftIcon className="h-5 w-5 inline-block" />
              Data Setup Settings /
            </button>
            <span className="cursor-pointer">{" " + "UOM Group Setup"}</span>
          </div>
          {
            <div className="flex items-center gap-2">
              <div
                style={{ maxWidth: "30rem", height: "2.6rem" }}
                className={`w-full  flex items-center rounded-md   ${
                  isFocused ? "border border-focus-color" : "input_border"
                }`}
              >
                <Select
                  className="z-30 text-xs placeholder:text-xs"
                  styles={customStyles}
                  value={
                    filterData?.searchColumn
                      ? searchFilter?.find(
                          (item) => item?.value === filterData?.searchColumn
                        )
                      : null
                  }
                  onChange={(e) => {
                    handleSelectChange(e);
                    setIsFocused(true);
                    if (searchRef && searchRef?.current) {
                      searchRef?.current?.focus();
                    }
                  }}
                  options={searchFilter}
                  placeholder="Select Column"
                  isSearchable={false}
                />{" "}
                <div
                  className={`h-full w-0.5 ${
                    isFocused
                      ? "border-r border-r-focus-color"
                      : "border-r border-r-D0D5DD"
                  }`}
                ></div>{" "}
                <input
                  ref={searchRef}
                  autoFocus={true}
                  onBlur={() => setIsFocused(false)}
                  onFocus={() => setIsFocused(true)}
                  placeholder={`Search`}
                  className=" table_search_input w-full rounded-md text-xs  h-full placeholder:text-xs placeholder:text-787878 pl-3"
                  type="text"
                  value={filterData?.searchValue}
                  onChange={(e) => {
                    setFilterData({
                      ...filterData,
                      searchValue: e.target.value,
                    });
                  }}
                />
                <span className="px-2">
                  <img
                    style={{
                      height: "25px",
                      width: "25px",
                    }}
                    src={search}
                    alt="search icon"
                  />
                </span>
              </div>
              <button
                type="submit"
                className="bg-primary text-white px-6 py-3 rounded-md flex justify-center fw_500 text-sm whitespace-nowrap"
                // onClick={() => setShowAddEdit(true)}
                onClick={() => {
                  navigate("/settings/uom-group-setup/add");
                }}
              >
                <span className="mx-1">+ New</span>
              </button>

              <div
                onClick={() => setIsModalOpen(true)}
                className="border-027A48 border-2 rounded-md flex items-center gap-2 text-nowrap px-5 py-2 fw_700"
              >
                <img width={20} height={30} src={excelImg} alt="excel-icon" />

                <span>Import</span>
              </div>
              <button
                type="button"
                onClick={() => {
                  downloadAllTemplates(initUploadUOM);
                }}
                className="border-027A48 border-2 rounded-md px-1 py-1"
              >
                <DownloadIcon fill="var(--success-color)" />
              </button>
            </div>
          }
        </div>

        {mainLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div
              style={{
                height: "calc(100% - 4rem)",
              }}
              className="overflow-auto rounded-xl table-container border border-gray-200"
            >
              <table className=" w-full ">
                <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                  <tr className="relative h-[50px]">
                    {tableHeading.map((heading, index) => (
                      <th
                        className={`text-start px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]`}
                        key={heading}
                      >
                        {heading?.toUpperCase()}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {uomGroupData?.map((item, index) => (
                    <>
                      <tr key={index}>
                        <td className="tab-cell text-sm fw_400 text-secondary w-50 p-8">
                          <div className="flex gap-2">
                            <button
                              onClick={() =>
                                setShowItemsOf(
                                  showItemsOf === index ? null : index
                                )
                              }
                              className="mr-2"
                            >
                              <img
                                src={
                                  showItemsOf === index
                                    ? checkBoxDownArrow
                                    : checkBoxRightArrow
                                }
                                alt="Toggle"
                              />
                            </button>
                            <span className="">{item.name}</span>
                          </div>
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-50 p-8">
                          {item.description}
                        </td>
                        <td className="tab-cell text-sm fw_400 text-secondary w-50 p-8">
                          {item.group_code ?? "--"}
                        </td>
                        <td className="tab-cell relative  w-[5rem] text-sm fw_400 text-secondary w-50 p-8">
                          <button onClick={() => setSelectedDotIndex(index)}>
                            <KibabMenu />
                          </button>

                          {selectedDOtIndex === index && (
                            <div
                              ref={componentRef}
                              style={{
                                position: "absolute",
                                right: "4.5rem",
                                boxShadow:
                                  "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                              }}
                              className="bg-white rounded w-40 z-20"
                            >
                              <div className="w-full p-4">
                                <button
                                  className="w-full flex align-middle gap-2 px-2 py-2"
                                  onClick={() => onCLickEdit(item)}
                                >
                                  <img src={EditIcon} />
                                  <span className="text-sm">Edit</span>
                                </button>
                                <button
                                  className="w-full flex align-middle gap-2 px-2 py-1"
                                  onClick={() => onClickDelete(item?.group_id)}
                                >
                                  <div>
                                    <DeleteIcon />
                                  </div>
                                  <span className="text-sm">Delete</span>
                                </button>
                              </div>
                            </div>
                          )}
                        </td>
                      </tr>
                      {showItemsOf === index && (
                        <tr key={`${index}-details`} className="">
                          <td colSpan="4" className="">
                            <div className="hide-scrollbar border-EAECF0 ml-10 border-2 rounded-md">
                              <table className="w-full ">
                                <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-10 ">
                                  <tr>
                                    {itemTableHeaders.map((heading) => (
                                      <th
                                        className="tab-header whitespace-nowrap text-sm fw_700 text-475467  text-start p-2"
                                        key={heading}
                                      >
                                        {heading?.toUpperCase()}
                                      </th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {item?.group_items?.map(
                                    (subItem, subIndex) => (
                                      <tr key={subIndex}>
                                        <td className="tab-cell text-sm fw_400 text-secondary p-2 w-24">
                                          {subItem.alt_quantity}
                                        </td>
                                        <td className="tab-cell text-sm fw_400 text-secondary p-2 w-24">
                                          {subItem.alt_uom}
                                        </td>
                                        <td className="tab-cell text-sm fw_400 text-secondary p-2 w-24">
                                          {subItem.base_quantity}
                                        </td>
                                        <td className="tab-cell text-sm fw_400 text-secondary p-2 w-24">
                                          {subItem.base_uom?.name}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>

      <BulkUomGroupModal
        reloadData={reloadData}
        setReloadData={setReloadData}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </InnerLayout>
  );
};

export default UomGroup;

export const initUploadUOM = [
  {
    index: 0,
    documentType: "UOM group",
    filename: "",
    expectedHeaders: ["name", "description", "group_code"],
  },
  {
    index: 1,
    documentType: "UOM item",
    filename: "",
    expectedHeaders: [
      "group_code",
      "base_uom_code",
      "alt_uom",
      "base_quantity",
      "alt_quantity",
    ],
  },
];
